import { Box, Card, Skeleton } from '@mui/material'

const STAT_COUNT = 6

/**
 * Loading state for the Manage Users data region (stat tiles + table) — rendered
 * inline while the users first load. The page header and the period toggle stay
 * live above it, so only the data-dependent content is skeletoned.
 */
export const ManageUsersSkeleton = () => (
  <>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', lg: 'repeat(6, 1fr)' },
        gap: 2,
      }}
    >
      {Array.from({ length: STAT_COUNT }).map((_, i) => (
        <Card key={i} sx={{ p: 3 }}>
          <Skeleton width={70} />
          <Skeleton width={44} height={28} />
        </Card>
      ))}
    </Box>
    <Skeleton variant="rounded" height={320} />
  </>
)
